import CallResultCodes from "./call-result-codes.module";
import Campaigns from "./campaigns.module";
import Channels from "./channels.module";
import MessageTemplates from "./message-templates.module";
import Packages from "./packages.module";
import RegistrationPeriods from "./registration-periods.module";
import ResultCodes from "./result-codes.module";
import SalePeriods from "./sale-periods.module";
import SmClasses from "./sm-classes.module";
import Trainings from "./trainings.module";

export default {
  channels: Channels,
  packages: Packages,
  trainings: Trainings,
  campaigns: Campaigns,
  messageTemplates: MessageTemplates,
  salePeriods: SalePeriods,
  registrationPeriods: RegistrationPeriods,
  smClasses: SmClasses,
  resultCodes: ResultCodes,
  callResultCodes: CallResultCodes,
};
